import admin from './admin/texts.js';
import activity from './components/activity/texts.js';
import config from './components/config/texts.js';
import deck from './components/deck/texts.js';
import layout from './components/layout/texts.js';
import material from './components/material/texts.js';
import selection from './components/selection/texts.js';
import wear from './components/wear/texts.js';
import fleet from './fleet/texts.js';

export default {
  view: {
    admin,
  },
  fleet,
  activity,
  config,
  deck,
  layout,
  material,
  selection,
  wear,
};
